import React from 'react'

import Caption from 'components/Luxkit/Typography/Caption'
import FormatCurrency from 'components/Common/FormatCurrency'
import LinePlaneFlyIcon from 'components/Luxkit/Icons/line/LinePlaneFlyIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'

interface Props {
  className?: string;
  align?: 'start' | 'center' | 'end';
  price: number;
  forTwoAdults: boolean;
  priceColour?: React.ComponentProps<typeof Caption>['colour'];
  'data-testid'?: string;
  pricePerPackage?: boolean;
}

function HotelPlusFlightsFrom({ className, align, price, forTwoAdults, priceColour = 'neutral-two', 'data-testid': testId, pricePerPackage = false }: Props) {
  return <BodyTextBlock
      className={className}
      variant="medium"
      wrap="pre-wrap"
      align={align}
      colour="neutral-two"
      startIcon={<LinePlaneFlyIcon colour="neutral-one" />}
      data-testid={testId}
    >
    <Caption variant="medium" as="span">Hotel + flights from&nbsp;</Caption>
    <Caption variant="medium" as="span" colour={priceColour} weight="bold">
      <FormatCurrency value={price} format="roundedDollar" />/{pricePerPackage && 'package'}*&nbsp;
    </Caption>
    {forTwoAdults && <Caption variant="medium" as="span" colour="neutral-three">
      (Two Adults)
    </Caption>}

  </BodyTextBlock>
}

export default HotelPlusFlightsFrom
